/**
 * SetVendorLoginAction
 * ─────────────────────────────────────────────────────────────────────────────
 * A standalone trigger for SetVendorLoginDialog, for directories whose "send
 * login" button is not SendVendorCredentialsAction (Brands uses its own owner
 * setup-link flow). Same render-prop contract as SendVendorCredentialsAction
 * and SignInAsVendorButton, so each directory keeps its own button look:
 *
 *   <SetVendorLoginAction vendorType="BRAND" vendorId={b._id} vendorName={b.name} visible={isSuperAdmin}>
 *     {({ open }) => <Button onClick={open}><FaUserLock /></Button>}
 *   </SetVendorLoginAction>
 *
 * `visible` is the caller's super-admin predicate. The server refuses everyone
 * else regardless; hiding the button is presentation only.
 */
import React, { useCallback, useState } from "react";

import SetVendorLoginDialog from "./SetVendorLoginDialog";

const SetVendorLoginAction = ({ vendorType, vendorId, vendorName, visible = false, children }) => {
  const [open, setOpen] = useState(false);
  const show = useCallback(() => setOpen(true), []);
  const hide = useCallback(() => setOpen(false), []);

  if (!visible) return null;
  return (
    <>
      {children({ open: show })}
      <SetVendorLoginDialog
        open={open}
        onClose={hide}
        vendorType={vendorType}
        vendorId={vendorId}
        vendorName={vendorName}
      />
    </>
  );
};

export default SetVendorLoginAction;
